import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useProfile } from "../../auth/hooks/useProfile";

const NO_ANSWERS: Record<string, number> = {};

const useSurvey = () => {
  const { answers: storedAnswers, completion_per: storedCompletionPer } =
    useSelector((state: RootState) => state.survey);

  const questionnaireId = useSelector(
    (state: RootState) => state.survey.questionnaireId,
  );

  // new_survey = 1: the user owes a retake. Mask the previous run entirely so the
  // whole app (nav, locker room, survey page) treats them as not-yet-started and
  // no stale results are shown. Cleared once the retake's first answer is saved.
  const { isNewSurvey } = useProfile();

  const surveyAnswers = useMemo(
    () => (isNewSurvey ? NO_ANSWERS : storedAnswers),
    [isNewSurvey, storedAnswers],
  );
  const surveyCompletionPer = isNewSurvey ? 0 : storedCompletionPer;

  const notStarted = Number(surveyCompletionPer) === 0 || undefined || null;
  const isCompleted = Number(surveyCompletionPer) === 100;
  const inProgress =
    Number(surveyCompletionPer) > 0 && Number(surveyCompletionPer) < 100;

  return {
    surveyAnswers,
    isCompleted,
    notStarted,
    inProgress,
    isNewSurvey,
    questionnaireId,
    completionPercentage: surveyCompletionPer,
  };
};

export default useSurvey;
